import Vue from 'vue';
import Vuex from 'vuex';
import { globalStore } from './globalStore';
import { level1Store } from './level1Store';
import { level3Store } from './level3Store';
import { prepareStore } from './prepareStore';
import { loaderStore } from './loaderStore';
import { customerLandingPageStore } from './customerLandingPageStore';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global: globalStore,
    level1: level1Store,
    level3: level3Store,
    prepare: prepareStore,
    loader: loaderStore,
    customerLandingPageStore: customerLandingPageStore,
  }
});
